import { Component } from '@angular/core';

@Component({
  selector: 'app-why',
  templateUrl: './why.component.html',
  standalone: false,
  styleUrl: './why.component.scss'
})
export class WhyComponent {}
